'use client'

import { ProductCardSkeleton } from '@/components/common/product-card/product-item-skeleton'
import { ProductCarousel } from '@/components/common/product-carousel'
import { useCollectionProductsNoFilter } from '@/hooks/react-query/products/use-collection-products'
import { useTranslations } from 'next-intl'

export const BirthdayListing = () => {
  const t = useTranslations()
  const { data, isLoading } = useCollectionProductsNoFilter({
    slug: 'coolmate-7th-birthday',
    limit: 15,
    hide_banner: true,
    show_variant_color: false,
    random_focus: false,
    flatten: 0,
  })

  if (isLoading) {
    return (
      <div className='w-full flex-1'>
        <div className='grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4'>
          {Array.from({ length: 8 }).map((_, index) => (
            <ProductCardSkeleton key={index} />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div id='scroll-to-birthday-products'>
      <ProductCarousel products={data?.pages[0]?.products || []} />
    </div>
  )
}
